module.exports = __webpack_public_path__ + "static/media/Pdf.8b4f01d5.svg";